import React, {useEffect, useState} from "react";
import ItemComponenttype from "./ItemComponenttype";


function ListComponenttype({items, currentObjectTypeId, setCurrentObjectTypeId, showAttributes, setShowAttributes, setCurrentObjectType, checkedAttributes, setCheckedAttributes, theRealm}) {
    const [showAttributesSub, setShowAttributesSub] = useState(false);

    useEffect(() => {
        if (items) {
            const newChecked = [...checkedAttributes];
            items.forEach(c => {
                c.attribute?.forEach(a => {
                    if (
                        a.data_type === 'standard' ||
                        (a.data_type === 'p_referencevalue' && (a.reference_field === 'realestateobject' || a.reference_field === 'component'))
                    ) {
                        if (!newChecked.includes(a.attribute_id)) {
                            newChecked.push(a.attribute_id);
                        }
                    }
                });
            });
            setCheckedAttributes(newChecked);
        }
    }, [items, setCheckedAttributes]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClick = (index, data) => {
        setCurrentObjectTypeId(index);
        setCurrentObjectType(data);
        setShowAttributes(false);
        setShowAttributesSub(false);
    };

    return (
        <div>
            {items?.map((item) => (
                <ItemComponenttype
                    key={item?.objecttype_id}
                    data={item}
                    index={item?.objecttype_id}
                    labelId={item?.objecttype_id}
                    currentObjectTypeId={currentObjectTypeId}
                    setCurrentObjectTypeId={setCurrentObjectTypeId}
                    setCurrentObjectType={setCurrentObjectType}
                    handleClick={handleClick}
                    showAttributes={showAttributes}
                    setShowAttributes={setShowAttributes}
                    showAttributesSub={showAttributesSub}
                    setShowAttributesSub={setShowAttributesSub}
                    checkedAttributes={checkedAttributes}
                    setCheckedAttributes={setCheckedAttributes}
                    theRealm={theRealm}
                />
            ))}
        </div>
    );
}

export default ListComponenttype;
